import { render, staticRenderFns } from "./EstatisticasTarefas.vue?vue&type=template&id=7a04228d"
import script from "./EstatisticasTarefas.vue?vue&type=script&lang=js"
export * from "./EstatisticasTarefas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports